import { useQuery } from '@apollo/client';

import {
  AdTypeEnum,
  QuerySearchSuggestionsArgs,
  SearchSuggestionsQuery
} from '@/__generated_graphql__/graphql';
import { GET_SUGGESTIONS } from '@/graphql/queries';
import { useParticipant } from '@/providers/ParticipantProvider';

type Props = { query: string };

export const useGetSuggestions = ({ query }: Props) => {
  const { isResumes } = useParticipant();

  const queryVariables: QuerySearchSuggestionsArgs = {
    searchTerm: query,
    targetType: isResumes ? AdTypeEnum.Resume : AdTypeEnum.Vacancy
  };

  const {
    data,
    previousData,
    loading,
    fetchMore: fetchMoreSuggestions
  } = useQuery<SearchSuggestionsQuery, QuerySearchSuggestionsArgs>(
    GET_SUGGESTIONS,
    {
      fetchPolicy: 'cache-and-network',
      variables: queryVariables
    }
  );

  const computedSearchSuggestions =
    (loading ? previousData?.searchSuggestions : data?.searchSuggestions) ?? [];

  const fetchMore = (searchTerm: string) => {
    fetchMoreSuggestions({
      variables: { ...queryVariables, searchTerm },
      updateQuery: (_, { fetchMoreResult }) => {
        return fetchMoreResult;
      }
    });
  };

  return {
    fetchMore,
    data: computedSearchSuggestions,
    loading
  };
};
